<template>
  <v-tooltip top>
    <template #activator="{ on, attrs }">
      <v-btn
        class="pa-0"
        :to="parentURL"
        depressed
        rounded
        small
        style="height: 30px; min-width: 30px"
        data-testid="back-btn"
        v-bind="{ ...attrs }"
        v-on="{ ...on }"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </template>
    <span>
      {{ title }}
      <template v-if="subtitle">
        <br /><span class="caption">{{ subtitle }}</span>
      </template>
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'BackListItem',
  props: {
    parent: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
    extraQueryParams: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    parentURL() {
      const url = this.parent.url
      if (typeof url === 'object') {
        url.query = { ...url.query, ...this.extraQueryParams }
      }
      return url
    },
  },
}
</script>
